import { useCallback } from "react";

import useFetchContract from "./use-fetch-contract";

const pipedriveURL = "prefill/pipedrive";

export default function usePrefillsPipedrive() {
  const {
    isLoading: useFetchContractIsLoading,
    error: useFetchContractError,
    get,
  } = useFetchContract();

  const getPrefill = useCallback(
    async (data: string) => {
      const res = (await get(`${pipedriveURL}/${data}`)) as any;

      return res.data;
    },
    [get]
  );

  return {
    isLoading: useFetchContractIsLoading,
    error: useFetchContractError,
    getPrefill,
  };
}
